export default __webpack_public_path__ + "static/media/videoChatReady.7842dcde.wav";